import { DashboardCard } from '@/common/dashboard/DashboardCard';
import { PieChart } from '@/common/dashboard/charts/PieChart';
import { Mode } from '@/common/entityFramework/enumerations/Mode';
import { useForm } from '@/common/form/FormContext';
import { useNavState } from '@/common/navState/NavStateContext';
import { ExprUtils } from '@/common/utils/ExprUtils';
import { useMemo } from 'react';

export const InctvRbtProgressChart = () => {
  const { formValues } = useForm();
  const { custExpr, ctrtExpr, startPeriodId, endPeriodId } = formValues;
  const reqParam = useMemo(
    () => ({ custExpr, ctrtExpr, startPeriodId, endPeriodId }),
    [custExpr, ctrtExpr, startPeriodId, endPeriodId],
  );

  const { navigateTo } = useNavState();

  const navigateToRbtList = (dataPoint) => {
    let expr = ExprUtils.and(
      ExprUtils.whereParams('rbtStatus', dataPoint.rebateStatus),
      ExprUtils.effectiveDateClause('endDate', dataPoint.minEndDate, dataPoint.maxEndDate),
    );

    if (custExpr) {
      expr = ExprUtils.and(expr, custExpr);
    }

    if (ctrtExpr) {
      expr = ExprUtils.and(expr, ctrtExpr);
    }

    const navState = {
      mode: Mode.LIST,
      expr: expr,
    };

    navigateTo('sc/inctv-rbt', navState);
  };

  return (
    <DashboardCard
      title={'Rebate Progress'}
      // TODO: FIX DESCRIPTION
      description={'Displays the Direct Sale Lines Incentive Rebate Progress'}
      reqParam={reqParam}
      module="sc"
      plugin="INCTV_RBT_PROGRESS_CHART_DATA_PLUGIN"
    >
      {(data) => <PieChart data={data} onClick={(dataPoint) => navigateToRbtList(dataPoint)} />}
    </DashboardCard>
  );
};
